export default __webpack_public_path__ + "static/media/summarize-icon-9.16f84f87.jpg";